// Module
var code = `<div role="radiogroup" aria-labelledby="block-label-{{block.id}}"> <div ng-repeat="choice in ['Male','Female']" class="radio"> <label> <input type="radio" show-errors name="{{ block.id }}" ng-required="block.required" ng-model="answer.value" ng-model-options="{ debounce: 300 }" ng-value="choice.charAt(0)"/> <strong>{{ choice }}</strong> </label> </div> </div> `;
// Exports
var _module_exports =code;;
var path = '/views/blocks/genderQuestion.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;